
<div class="modal-body">
  <article [innerHTML]="content"></article>
</div>
<div class="modal-footer"><a class="btn btn-outline-primary" (click)="close()" permissionShow="system:admin-access" href="/about" translate>About ELEMENTS</a>
  <button class="btn btn-outline-secondary" (click)="close()" translate>Close</button>
</div>